module.exports = __webpack_public_path__ + "static/media/home-icon.dc4fd1af.svg";